import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiConstant } from 'src/app/utility/constant/api-constant';
import {
    AddUserRoleRequest,
    DeleteProjectUserRoleRequest,
    UpdateProjectUserRoleRequest,
} from 'src/app/model/user-role.model';

export interface Collaborator {
    user_id: string;
    first_name: string;
    last_name: string;
    full_name: string;
    initials: string;
    email: string;
    role: string;
    current_user: boolean;
}

export interface FetchCollaboratorsResponse {
    is_success: boolean;
    message: string;
    data: {
        collaborators: Collaborator[];
        max_owners?: number | null;
    };
}

@Injectable({
    providedIn: 'root',
})
export class ShareService {
    private readonly apiEndpoint = import.meta.env.NG_APP_API_URL;

    constructor(private readonly http: HttpClient) { }

    fetchUserDetails(searchString: string): Observable<any> {
        return this.http.get<any>(
            this.apiEndpoint +
            `${apiConstant.fetchUsersList}?search_string=${encodeURIComponent(searchString)}`
        );
    }

    addProjectUser(payload: AddUserRoleRequest): Observable<any> {
        return this.http.post(
            this.apiEndpoint + apiConstant.addProjectUser,
            payload
        );
    }

    deleteProjectUserRole(payload: DeleteProjectUserRoleRequest): Observable<any> {
        return this.http.delete(
            this.apiEndpoint + apiConstant.deleteProjectUserRole,
            { body: payload }
        );
    }

    updateProjectUserRole(payload: UpdateProjectUserRoleRequest): Observable<any> {
        return this.http.put(
            this.apiEndpoint + apiConstant.updateProjectUserRole,
            payload
        );
    }

    fetchProjectDetailsByProjectId(projectId: string): Observable<any> {
        return this.http.get<any>(
            this.apiEndpoint +
            `${apiConstant.fetchProjectEC}?project_id=${projectId}`
        );
    }

    fetchCollaborators(
        projectId: string,
        projectVersionId: string
    ): Observable<FetchCollaboratorsResponse> {
        return this.http.get<FetchCollaboratorsResponse>(
            this.apiEndpoint +
            `${apiConstant.fetchCollaborators}?project_id=${encodeURIComponent(projectId)}&project_version_id=${encodeURIComponent(projectVersionId)}`
        );
    }
}
